import { CarInsuranceInfo } from "./CarInsuranceChargeTypes";
import { DriverInfo } from "./DriverTypes";

export type AlertType = {
  title: string;
  content: string;
  show: boolean;
  callback?: () => void;
};

export type AdminLicenseCheckAlertType = {
  title: string;
  content: string;
  show: boolean;
  callback?: () => void;
  onClose?: () => void;
};

export type ConfirmType = {
  title: string;
  content: string;
  isOpen: boolean;
  callback?: () => void;
};

export const confirmType: ConfirmType = {
  title: "",
  content: "",
  isOpen: false,
  callback: undefined
};

export const alertType: AlertType = {
  title: "",
  content: "",
  show: false,
  callback: undefined
};

export type KeyboardType = {
  adminKeyboardShow?: boolean;
  keyboardShow?: boolean;
  keyboardType?: string;
};

export const keyboardTypeInit: KeyboardType = {
  adminKeyboardShow: false,
  keyboardShow: false,
  keyboardType: ""
};

export type KeyboardInputType = {
  keyboardInputValue: string;
  keyboardTypeName: string;
  keyboardDecript: string;
};

export const keyboardInputInit: KeyboardInputType = {
  keyboardInputValue: "",
  keyboardTypeName: "",
  keyboardDecript: ""
};

export const equlesDlvLicenseValid: {
  field: keyof DriverInfo;
  errorMessage: string;
}[] = [
  { field: "driverName", errorMessage: "운전자 이름을 입력해주세요." },
  { field: "birthday", errorMessage: "운전자 생년월일을 입력해주세요." },
  { field: "licenseNum", errorMessage: "운전자 면허번호를 입력해주세요." },
  { field: "licenseType", errorMessage: "운전자 면허종류를 선택해주세요." }
];

export const validationItems: {
  field: keyof DriverInfo;
  errorMessage: string;
  validator?: (value: any, resInfo?: any, driverValue?: DriverInfo) => boolean | string;
  resInfo?: any;
}[] = [
  {
    field: "emContactNumber",
    errorMessage: "비상연락처를 확인해주세요.",
    validator: (value: string, resInfo: any, driverValue?: DriverInfo) => {

      // 부운전자는 검증 안 함
      if(driverValue && driverValue.orderNum === 1) {
        return true;
      }

      if(!value) {
        return "비상연락처를 입력해주세요.";
      }

      const isNotFormatted = value.replace(/-/g, "").length < 11;
      if(isNotFormatted) {
        return "비상연락처는 (000-0000-0000) 형식이어야 합니다.";
      }

      const mobilePhoneNumberPattern = /^(01[016789]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

      if(!mobilePhoneNumberPattern.test(value)) {
        return false;
      }

      if(driverValue && (driverValue.tel === value)) {
        const driverTypeName = (driverValue.orderNum === 0) ? "주운전자" : "부운전자";
        return driverTypeName + " 연락처와 비상연락처를 다르게 입력해주세요."
      }

      return true;
    }
  },
  {
    field: "licenseCerti",
    errorMessage: "면허 검증이 완료 되지 않았습니다.",
    validator: (value: boolean) => value === true
  },
  { field: "driverName", errorMessage: "운전자 이름을 확인해주세요." },
  {
    field: "birthday",
    errorMessage: "운전자 생년월일을 확인해주세요.",
    validator: (value: string, resInfo: any) => {
      const birthday = !isValidDate(formatDate(value));
      if (birthday) {
        return "운전자 생년월일을 확인해주세요.";
      }

      const ageFromBirthDay = Number(calculateAgeFromBirthdate(formatDate(value)));

      // 보험 가입 최소 연령 검증
      const insMinAge =
        resInfo && resInfo.carInsuranceChargeInfo.length > 0
          ? resInfo.carInsuranceChargeInfo[0].carInsuranceInfo.minAge
          : 0;

      const cantRentByInsMinAge =
        resInfo &&
        resInfo.carInsuranceChargeInfo.length > 0 &&
        resInfo.carInsuranceChargeInfo.some((insurance: CarInsuranceInfo) => {
          return insurance?.carInsuranceInfo?.minAge
            ? ageFromBirthDay < Number(insurance.carInsuranceInfo.minAge)
            : false;
        });
      if (cantRentByInsMinAge) {
        return `만 나이 ${insMinAge}세 이상만 가입 가능한 보험 상품입니다.`;
      }

      // 보험 가입 최대 연령 검증
      const insMaxAge =
        resInfo && resInfo.carInsuranceChargeInfo.length > 0
          ? resInfo.carInsuranceChargeInfo[0].carInsuranceInfo.maxAge
          : 9999;

      const cantRentByInsMaxAge =
        resInfo &&
        resInfo.carInsuranceChargeInfo.length > 0 &&
        resInfo.carInsuranceChargeInfo.some((insurance: CarInsuranceInfo) => {
          return insurance?.carInsuranceInfo?.maxAge
            ? ageFromBirthDay > Number(insurance.carInsuranceInfo.maxAge)
            : false;
        });
      if (cantRentByInsMaxAge) {
        return `만 나이 ${insMaxAge}세 이하만 가입 가능한 보험 상품입니다.`;
      }


      // 대여 최대 연령 검증
      // rentCondMaxAge 없으면 75로 처리
      const rentMaxAge = resInfo.rentCondMaxAge ? Number(resInfo.rentCondMaxAge) : 75;
      const cantRentByCondMaxAge = ageFromBirthDay > rentMaxAge;
      if (cantRentByCondMaxAge) {
        return `만 ${rentMaxAge}세 이하만 대여가 가능한 차량입니다.`;
      }

      // 대여 최소 연령 검증
      const rentMinAge = resInfo.rentCondAge ? Number(resInfo.rentCondAge) : 0;
      const cantRentByCondMinAge = ageFromBirthDay < rentMinAge;
      if (cantRentByCondMinAge) {
        return `만 나이 ${rentMinAge}세 이상만 대여 가능한 차량입니다. (생년월일 확인))`;
      }

      return true;
    }
  },

  {
    field: "licenseNum",
    errorMessage: "면허번호를 확인해주세요.",
    validator: (value: string, resInfo: any) => {
      if (!value) return "면허번호를 확인해주세요.";

      // if (value) {
      //     console.log(value.replace(/-/g, ""))
      //     if (value.replace(/-/g, "").length < 12 || value.replace(/-/g, "").length > 12) {
      //         return "운전면허번호는 12자리입니다.</br> 면허번호를 확인해주세요."
      //     }
      // }

      /* == 04.29 면허 상 경력이 미달이어도, 관리자 승인으로 처리 가능하도록 수정 == */
      /* 이후 다시 막는 경우 맨 아래까지 주석 해제 */
      // const licensNumberIncludeHyphen = addHyphenToLicenseNumber(value);
      // const driverCareer = calculateDrivingExperience(licensNumberIncludeHyphen).yearsOfExperience;
      // if (
      //   licensNumberIncludeHyphen.includes("-") &&
      //   driverCareer < Number(resInfo.rentCondLicenseYear)
      // ) {
      //   return `운전 경력 ${resInfo.rentCondLicenseYear}년 이상 이용 가능합니다.`;
      // } 

      // const insMinCareer = 
      // resInfo && resInfo.carInsuranceChargeInfo.length > 0
      //   ? resInfo.carInsuranceChargeInfo[0].carInsuranceInfo.minCareer
      //   : 0;

      // if( insMinCareer > driverCareer) {
      //   return `운전 경력 ${insMinCareer}년 이상만 가입 가능한 보험 상품입니다.`;
      // }

      return true;
    }
  },
  { field: "licenseType", errorMessage: "면허종류를 확인해주세요." },
  {
    field: "tel",
    errorMessage: "운전자 연락처를 확인해주세요.",
    validator: (value: string) => {
      const val = value.replace(/-/g, "").length < 11;
      const mobilePhoneNumberPattern = /^(01[016789]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

      if(val || !mobilePhoneNumberPattern.test(value)) {
        return false;
      }
      return true;
    }
  }
];

const isValidDate = (dateString: string) => {
  // 날짜 형식을 검증하기 위한 정규 표현식
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;
  const datePatternWithHyphen = /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/; 

  // 정규 표현식과 문자열을 비교하여 검증
  if (!datePattern.test(dateString)) {
    return false;
  }

  if (!datePatternWithHyphen.test(dateString)) {
    return false;
  }

  // 유효한 날짜인지 확인
  const [year, month, day] = dateString.split("-").map(Number);

  if (month < 1 || month > 12) {
    return false; // 올바른 월 범위 확인
  }

  const maxDay = new Date(year, month, 0).getDate(); // 해당 월의 최대 일 수 계산
  if (day < 1 || day > maxDay) {
    return false; // 올바른 일 범위 확인
  }

  return true; // 모든 검증 통과
};

export const formatDate = (birthday: string): string => {
  if (birthday.length !== 6) {
    return birthday;
  }
  const year = birthday.slice(0, 2);
  const month = birthday.slice(2, 4);
  const day = birthday.slice(4, 6);

  const currentYear = new Date().getFullYear();
  const fullYear =
    parseInt(year) + (parseInt(year) >= currentYear % 100 ? 1900 : 2000); // 1900년과 2000년도 구분

  return `${fullYear}-${month}-${day}`;
};

const calculateAgeFromBirthdate = (birthdate: string): number => {
  // "yyyy-mm-dd" 형식을 받아서 나이를 계산
  const birthYear = parseInt(birthdate.substr(0, 4)); // 연도
  const birthMonth = parseInt(birthdate.substr(5, 2)) - 1; // 월
  const birthDay = parseInt(birthdate.substr(8, 2)); // 일

  const birthDate = new Date(birthYear, birthMonth, birthDay);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};

export const addHyphenToLicenseNumber = (licenseNumber: string): string => {
  if (!licenseNumber) return licenseNumber;
  // 이미 하이픈이 포함된 형태인지 확인
  // 02-24. 한글 처리 대응 추가 - 임시면허증은 앞에 2자리가 지역명(한글)이 들어감
  const regex = /^[0-9가-힣]{2}-[0-9]{2}-[0-9]{6}-[0-9]{2}$/u;
  const isAlreadyFormatted = regex.test(licenseNumber);
  if (isAlreadyFormatted) return licenseNumber; // 이미 형식에 맞게 하이픈이 있는 경우 그대로 반환

  // 하이픈을 추가하여 반환
  // 02-24. 한글 처리 대응 추가 - 임시면허증은 앞에 2자리가 지역명(한글)이 들어감
  const replaceRegex = /([0-9가-힣]{2})(\d{2})(\d{6})(\d{2})/u;
  const addedHyphenResult = licenseNumber.replace(replaceRegex, "$1-$2-$3-$4");
  return addedHyphenResult;
};

const sliceLicenseNumber = (licenseNumber: string): string => {
  const index = licenseNumber.split("-");

  return index[1];
};

const calculateYearsSinceIssued = (issueYearLastTwoDigits: number): number => {
  const currentYearLastTwoDigits = parseInt(
    String(new Date().getFullYear()).slice(-2)
  );

  // 2000년 이전의 발급 연도
  if (issueYearLastTwoDigits > currentYearLastTwoDigits) {
    return 1900 + issueYearLastTwoDigits;
  }
  // 2000년 이후의 발급 연도
  else {
    return 2000 + issueYearLastTwoDigits;
  }
};

export const calculateDrivingExperience = (
  licenseNumber: string
): { yearsOfExperience: number; is2000s: boolean } => {
  const currentYearLastTwoDigits = parseInt(
    String(new Date().getFullYear()).slice(-2)
  ); // 현재 연도 마지막 두 자리

  const parts = licenseNumber.split("-");
  if (parts.length < 2 || parts[1].length < 2) {
    console.error("운전면허번호의 발급 연도가 올바르지 않습니다."); // 잘못된 형식 경고
  }
  const currentCentury = Math.floor(new Date().getFullYear() / 100) * 100; // 현재 세기

  const issueYearLastTwoDigits = parseInt(
    licenseNumber.split("-")[1].slice(0, 2)
  ); // 운전면허번호에서 발급 연도 추출

  // 발급 연도의 세기 계산 (현재 연도의 마지막 두 자리를 기준으로 1900년대인지 2000년대인지 판단)
  const issueCentury =
    issueYearLastTwoDigits <= currentYearLastTwoDigits
      ? currentCentury
      : currentCentury - 100;
  const issueYear = issueCentury + issueYearLastTwoDigits; // 발급 연도 완성
  const currentYear = currentCentury + currentYearLastTwoDigits; // 현재 연도 완성

  const yearsOfExperience = currentYear - issueYear; // 경과한 연도 계산
  const is2000s = issueYear >= 2000; // 2000년대인지 여부 확인

  return {
    yearsOfExperience,
    is2000s
  };
};
